$(document).ready(function () {
    $('.show-password').on('click', function () {
        $(this).parent().closest('.form-password').toggleClass('open-password');
        let input = $(this).parent().find($('.main-form-control'));

        if(input[0].type === 'password') {
            input[0].type = 'text';
        } else {
            input[0].type = 'password';
        }
    })
})
$(document).ready(function () {
    $(".show-password--profile").on("click", function () {
        $(this)
            .parent()
            .closest(".form-password")
            .toggleClass("open-password--profile");
        let input = $(this).parent().find($(".main-form-control--patient"));
        console.log(input[0].type);
        if (input[0].type === "password") {
            input[0].type = "text";
        } else {
            input[0].type = "password";
        }
    });
});
